import React from "react"
import { AuthProvider } from "./src/auth/AuthProvider"
import { GlobalStyle } from "./src/styles/GlobalStyle"
import LangProvider from "./src/components/Provider"

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <GlobalStyle />
      <LangProvider>
        <AuthProvider>{element}</AuthProvider>
      </LangProvider>
    </>
  )
}
